import { render } from "./KujdestaritContact.vue?vue&type=template&id=410085e9&scoped=true"
import script from "./KujdestaritContact.vue?vue&type=script&lang=js"
export * from "./KujdestaritContact.vue?vue&type=script&lang=js"

import "./KujdestaritContact.vue?vue&type=style&index=0&id=410085e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410085e9"]])

export default __exports__